import createIcon from '../../createIcon';

/**
 * @component @name ImagesearchRoller
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMS41VjcuNUg3VjUuNUg1VjkuNUgxNVYxNC41SDE3VjIyLjVIMTFWMTQuNUgxM1YxMS41SDNWMy41SDdWMS41IiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ImagesearchRoller = createIcon('ImagesearchRoller', [
  [
    'path',
    { d: 'M21 1.5V7.5H7V5.5H5V9.5H15V14.5H17V22.5H11V14.5H13V11.5H3V3.5H7V1.5', key: '1ncx2d' },
  ],
]);

export default ImagesearchRoller;
